"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5548],{

/***/ 525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(__webpack_require__(67294));

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowLeftIcon = function ArrowLeftIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.className || '');

  return React.createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React.createElement('path', { d: 'M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z' })
  );
};

var ArrowLeftIcon$1 = React.memo ? React.memo(ArrowLeftIcon) : ArrowLeftIcon;

module.exports = ArrowLeftIcon$1;


/***/ }),

/***/ 18799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(__webpack_require__(67294));

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MagnifyIcon = function MagnifyIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.className || '');

  return React.createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React.createElement('path', { d: 'M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z' })
  );
};

var MagnifyIcon$1 = React.memo ? React.memo(MagnifyIcon) : MagnifyIcon;

module.exports = MagnifyIcon$1;


/***/ }),

/***/ 88251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(__webpack_require__(67294));

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MenuDownIcon = function MenuDownIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'mdi-icon ' + (props.className || '');

  return React.createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React.createElement('path', { d: 'M7,10L12,15L17,10H7Z' })
  );
};

var MenuDownIcon$1 = React.memo ? React.memo(MenuDownIcon) : MenuDownIcon;

module.exports = MenuDownIcon$1;


/***/ }),

/***/ 77249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ OmnibarButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83852);
/* harmony import */ var mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88251);
/* harmony import */ var mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74815);
/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44632);






function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    position: relative;\n    padding: 0 1rem 0 1.4rem;\n    font-size: 1.06rem;\n    font-weight: ",
        ";\n    font-family: 'Roboto', sans-serif;\n    background: none;\n    background-color: ",
        ";\n    border-radius: 0;\n    border: none;\n    outline: none;\n    color: ",
        ";\n\n    cursor: pointer;\n\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 2px solid transparent;\n      border-radius: inherit;\n\n      box-sizing: border-box;\n    }\n\n    &:hover {\n      background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    &:focus,\n    &:active {\n      background-color: ",
        ";\n\n      &::after {\n        border-color: ",
        ";\n      }\n    }\n\n    > span.spacer {\n      flex: 1;\n    }\n\n    > svg {\n      margin-left: 0.2rem;\n      color: ",
        ";\n\n      &:first-child {\n        margin-left: 0rem;\n        margin-right: 0.3rem;\n      }\n    }\n\n    .badge {\n      margin-right: 0;\n      margin-left: 0.5rem;\n      font-weight: normal;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styled = {
    Button: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
        componentId: "sc-3857a0a2-0"
    })(_templateObject(), function(param) {
        var primary = param.primary;
        return primary ? 500 : 'bold';
    }, function(param) {
        var primary = param.primary;
        return primary ? _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary : 'transparent';
    }, function(param) {
        var primary = param.primary;
        return primary ? _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.white */ .Il.white : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.secondary */ .Il.secondary;
    }, function(param) {
        var primary = param.primary;
        return primary ? (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(0.1, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary) : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.hover */ .Il.hover;
    }, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.secondary */ .Il.secondary, function(param) {
        var primary = param.primary;
        return primary ? (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .darken */ ._j)(0.1, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary) : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.select */ .Il.select;
    }, _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary, function(param) {
        var primary = param.primary;
        return primary ? _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.white */ .Il.white : _Theme__WEBPACK_IMPORTED_MODULE_2__/* .Color.primary */ .Il.primary;
    })
};
var OmnibarButton = function(param) {
    var icon = param.icon, _count = param.count, count = _count === void 0 ? 0 : _count, iconRight = param.iconRight, _primary = param.primary, primary = _primary === void 0 ? false : _primary, _className = param.className, className = _className === void 0 ? '' : _className, onClick = param.onClick, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Styled.Button, {
        className: className,
        primary: primary,
        onClick: onClick,
        children: [
            icon || null,
            " ",
            children,
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "spacer"
            }),
            " ",
            count > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge__WEBPACK_IMPORTED_MODULE_3__/* .Badge */ .C, {
                children: count
            }),
            ' ',
            iconRight !== undefined ? iconRight : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_MenuDownIcon__WEBPACK_IMPORTED_MODULE_1___default()), {})
        ]
    });
};


/***/ }),

/***/ 95548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MobileBar": function() { return /* binding */ MobileBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87379);
/* harmony import */ var mdi_react_ArrowLeftIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(525);
/* harmony import */ var mdi_react_ArrowLeftIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(mdi_react_ArrowLeftIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74815);
/* harmony import */ var _omnibar_OmnibarButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77249);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var mdi_react_MagnifyIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18799);
/* harmony import */ var mdi_react_MagnifyIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(mdi_react_MagnifyIcon__WEBPACK_IMPORTED_MODULE_6__);









function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  display: flex;\n  margin: 0;\n  height: 66px;\n  background-color: ",
        ";\n  border-radius: 0;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e0ada826-0"
})(_templateObject1(), _Theme__WEBPACK_IMPORTED_MODULE_3__/* .cardStyles */ .F, _Theme__WEBPACK_IMPORTED_MODULE_3__/* .Color.white */ .Il.white, _Theme__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.mobileFirst.medium */ .cy.mobileFirst.medium((0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject())));
var MobileBar = function(param) {
    var _showBack = param.showBack, showBack = _showBack === void 0 ? false : _showBack;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), back = ref.back, push = ref.push;
    var handleSearchClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (showBack) return back();
        return push('/search');
    }, [
        showBack
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_omnibar_OmnibarButton__WEBPACK_IMPORTED_MODULE_4__/* .OmnibarButton */ .j, {
            icon: showBack ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_ArrowLeftIcon__WEBPACK_IMPORTED_MODULE_2___default()), {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((mdi_react_MagnifyIcon__WEBPACK_IMPORTED_MODULE_6___default()), {}),
            iconRight: null,
            onClick: handleSearchClick,
            children: showBack ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                id: "search.backButton",
                defaultMessage: "Takaisin hakuun"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                id: "search.goToSearchButton",
                defaultMessage: "Avaa haku"
            })
        })
    }));
};


/***/ })

}]);